__turbopack_context__.v({
  "legalsLinks": "styles-module-scss-module__yqJ0Mq__legalsLinks",
  "userInfoRow": "styles-module-scss-module__yqJ0Mq__userInfoRow",
  "userInfoRowTitle": "styles-module-scss-module__yqJ0Mq__userInfoRowTitle",
  "userInfoRowValue": "styles-module-scss-module__yqJ0Mq__userInfoRowValue",
});
